import React, { useId, useState } from 'react'
import { Link } from 'react-router-dom'
import { RoundCard, RunnerUpHeader, TableWork, UnderLine } from '../../../ui'
import Breadcrumb from '../../../library/components/BreadCrumbs'
import { GENERATE_EPBPIN } from '../../../constants/constants'
import {
  useGenerateEpbPinAndIdQuery,
  useGetServiceVoterCountQuery,
  useGetserviceVotersDataQuery,
} from '../../../services/finalizeGenerateViewTransmitService'
import { useEffect } from 'react'
import LeftMenu from '../../AnalyticsModule/Left'
import CustomModal from '../../../library/components/Modal/otpmodal'
import GenerateEpbPin from './GenerateEpbPin'
import Button from '../../../library/components/Button'
import ConfirmationModal from '../../../library/components/FileUpload/ConfirmationModal/ConfirmationModal'
import { ALERT_TYPE_SUCCESS } from '../../../constants/constants'
import { useDispatch } from 'react-redux'
import { createAlert } from '../../../features/alert/alerts'
import { parseJwt } from '../../utilities/utils'
import RunnerUpHeaderNew from '../../../ui/runnerUpHeader/RunnerUpHeaderNew'


const acWiseCountTableHeader = [
  'S. No.',
  'AC No. & Name',
  'Total SV Data Uploaded',
]

const vottersTableHeader = [
  'S.No',
  'AC No.',
  'Serial No. in Part',
  // 'Part No.',
  'Name of Service Elector',
]
// let constType = parseJwt(localStorage.access_token)?.constituencyType;
// let userAc =
// constType === "AC"
//   ? parseJwt(localStorage.access_token)?.authorizedAcs?.[0]
//   : parseJwt(localStorage.access_token)?.authorizedPcs?.[0];

const Transmitepbpin = ({epbdetails,postfetch}) => {
  const [acWiseVotersData, setAcWiseVotersData] = useState([])
  const [votersData, setVotersData] = useState([])
  const [totalSVCount, setTotalSVCount] = useState(0)
  const [UserIds, setUserids] = useState([])
  const { data: AcWiseVoterData,refetch } = useGetServiceVoterCountQuery()
  const { data: getSvData } = useGetserviceVotersDataQuery()
  const [showModal, setShowModal] = useState(false)
  const [showConfirmationModal, setShowConfirmationModal] = useState(false)
  const [roNumber,setRoNumber] = useState('')
  const [skip, setSkip] = useState(true)
  const { data: saveDetails, isSuccess, isError} = useGenerateEpbPinAndIdQuery('', {
    skip: skip,
  })

 const dispatch = useDispatch()
  useEffect(() => {
    let tableData = []
    setTotalSVCount(AcWiseVoterData?.payload?.totalSVCount)
    AcWiseVoterData?.payload?.svdataCountDto?.map((item, i) => {
      if(i==0){
        setRoNumber(item.roNumber)
      }
      tableData.push({
        'S.No': i + 1,
        'AC_No&Name': `${item.assemblyConstituencyNumber} - ${item.acName}`,
        Total_SV: item.serviceVoterCountByAssemblyConstituency,
      })
      setAcWiseVotersData(tableData)
    })
  }, [AcWiseVoterData])

  useEffect(() => {
    if (getSvData) {
      let tableData = []
      let userId = []
      getSvData?.payload?.map((item, i) => {
        tableData.push({
          "S.No":i+1,
          AC_NO: item.assemblyConstituencyNumber,
          s_no: item.slNoInPart,
          // part_no: item.partNumber,
          service_name: item.fullName,
        })
        userId.push(item.id)
      })
      setVotersData(tableData)
      setUserids(userId)
    }
  }, [getSvData])

  const onClose = () => {
    setShowModal(false)
  }
  const onCloseIcon=()=>{
    setShowModal(false)
  }

  const onSuccess = (msg) => {
    dispatch(
      createAlert({
        message: msg,
        type: ALERT_TYPE_SUCCESS,
        heading: 'Success',
      }),
    )
  }
  
  const transmitEpbPin = () => {
    setSkip(false)
  }
  useEffect(() => {
    if (isSuccess) {
      setShowModal(false)
      refetch()
      onSuccess("e-PB & Pin Transmitted Successfully")
      postfetch()
    }
    if (isError) {
      setShowModal(false)
    }
    setSkip(true)
  }, [isSuccess , isError])

  return (
      <div className="container my-2">
    
        <div className="box" style={{overflow:"hidden"}}>
        <div className="ml-2 mr-2">
    <h6 className='col-md-12' style={{textAlign:"center"}}>Transmit e-PB & PIN</h6>
    </div>
    <CustomModal
        className="custom_modal confirm-modal"
        show={showConfirmationModal}
        // onClose={onClose}
        size="55%"
        closeIcon={false}
        modalTitle='Are you sure you want to transmit the e-PB & PIN ?'
        children={
          <ConfirmationModal
            noOption={() => {
              setShowConfirmationModal(false)
            }}
            yesOption={() => {
              setShowConfirmationModal(false)
              setShowModal(true)
            }}
          />
        }
      />
      <CustomModal
        className="custom_modal confirm-modal"
        show={showModal}
        modalTitle={true}
        onCloseIcon={onCloseIcon}
        size="55%"
        closeIcon={true}
        // modalTitle={props.localLang?.CONFIRMATION_POPUP?.TITLE}
        children={
          <GenerateEpbPin
            module={"Finalize"}
            onConfirm={transmitEpbPin}
            showConfirmationBox={true}
            message={'Transmit e-PB & PIN'}
            number={roNumber}
            onShowModal={()=>setShowModal(false)}
          />
        }
      />
          <RunnerUpHeaderNew title={"Data uploaded by ERO"}
            state={<span
                  >
                    State: {AcWiseVoterData?.state}{" "}
                    <span style={{marginLeft: "13px"}}></span>Constituency : {AcWiseVoterData?.constituencyNumber}
                    {""} - 
                    {AcWiseVoterData?.constituencyName} -{" "}
                    {AcWiseVoterData?.constituencyType}
                  </span>}
              />
          <TableWork
            id="Data uploaded by ERO"
            theadData={acWiseCountTableHeader}
            tbodyData={acWiseVotersData}
            anchorTagName=""
            anchorTagclassName="viewDetails"
            emptyMessage="No data found"
            pageSize={10}
            pagination={true}
            paginationClass={'text-right p-0'}
          />
          <span className="trans-spn mt-2 ml-2">
            <p>Total No. of Service Voters&nbsp;</p>{' '}
            <strong>{totalSVCount}</strong>
          </span>
          <UnderLine />
          <span className="trans-spn mt-2 ml-2">
            <strong>List of Service Voters&nbsp;</strong>
            <p className={AcWiseVoterData?.payload?.svdataCountDto?.[0]?.epbPinGenerated == 'Y'?"text-success font-weight-bold":""}>
              {AcWiseVoterData?.payload?.svdataCountDto?.[0]
                ?.epbPinGenerated !== 'Y'
                ? '(Yet to be Transmitted)'
                : '(e-PB Pin Transmitted)'}
            </p>
          </span>
          <TableWork
            id="List of Service Voters"
            theadData={vottersTableHeader}
            tbodyData={votersData}
            anchorTagName=""
            anchorTagclassName="viewDetails"
            emptyMessage="No data found"
            pageSize={10}
            pagination={true}
            paginationClass={'text-right p-0'}
          />
          {AcWiseVoterData?.payload?.svdataCountDto?.[0]?.epbPinGenerated !==
            'Y' ? epbdetails?.payload.epbPaperFlag !=="Y"?null :
            <p
            style={{ padding: '18px', textAlign: 'center' ,cursor:'pointer', maxWidth:"208px !important"}}
            className="button-link"
            onClick={()=>{
              setShowConfirmationModal(1)
            }}
          >
            Transmit e-PB & PIN
          </p>
            :null
          }
        </div>
      </div>
  )
}

export default Transmitepbpin
